import React, { useEffect, useRef, useState } from 'react';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import PublicProposedPage from './components/proposed/PublicProposed';
import PublicPageLayout from '../../../layout/publicPageLayout/PublicPageLayout';
import './Rules.scss';
import RuleNavigation from './components/ruleNavigation/RuleNavigation';
import Search from './components/search/Search';
import { useNavigate } from 'react-router-dom';

interface IRulesProps {
  rules?: boolean;
  resetPassword?: boolean;
  activateAccount?: boolean;
  selected?: number;
}

function RulesPage(props: IRulesProps) {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<number>(props.selected ?? 0);
  const [agencyId, setAgencyId] = useState<number | null>(null);
  const [titleId, setTitleId] = useState<number | null>(null);
  const handleSelect = (e: TabStripSelectEventArguments) => {
    switch (e.selected) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/browse-rules');
        break;
      case 2: 
        navigate('/docket');
        break;
      default:
        navigate('/');
        break;
    }
    setSelected(e.selected);
  };

  useEffect(() => {
    if (props.rules === true) {
      let queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      setAgencyId(urlParams.get('agencyId') !== null ? +urlParams.get('agencyId')! : null);
      setTitleId(urlParams.get('titleId') !== null ? +urlParams.get('titleId')! : null);
      let ruleNavigationTab = 1;
      setSelected(ruleNavigationTab);
    }
    const tabList = document.querySelector('#rule-management-tabs')
    tabList && tabList.setAttribute('aria-label', 'Methods for searching rules')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const renderRulesView = () => {
    return (
      <div className="body">
        <div className='rule-management'>
          <div>
            <h1 className="rules-header-text">Rules and Regulations</h1>
            <hr />
          </div>
          <TabStrip
            selected={selected}
            onSelect={handleSelect}
            className='rule-management tab-container'
            id="rule-management-tabs"
          >
            {/* Search Rules and Regulations by Keyword */}
            <TabStripTab title='Search Rules & Regulations' disabled={false}>
              <Search />
            </TabStripTab>

            {/*Navigate rule text*/}
            <TabStripTab title='Browse Rules by Agency'>
              <RuleNavigation titleId={titleId} agencyId={agencyId} />
            </TabStripTab>

            {/* Proposed rules and regulations docket */}
            <TabStripTab title='Proposed Rules & Regulations Docket' disabled={false} contentClassName='rule-container'>
              <div style={{ marginTop: '1rem' }}>
                <h2 style={{ color: '#3271E7' }}>Proposed Rules & Regulations Docket</h2>
                <PublicProposedPage />
              </div>
            </TabStripTab>
          </TabStrip >
        </div>
      </div>
    );
  };

  return (
    <PublicPageLayout resetPassword={props.resetPassword} activateAccount={props.activateAccount}>
      <div className='chapters-results'>{renderRulesView()}</div>
    </PublicPageLayout>
  );
}

export default RulesPage;
